var React = require('react');

function ChevronDown (props) {
    return React.createElement("svg",props,[React.createElement("desc",{"key":0},"Created with Sketch."),React.createElement("g",{"fillRule":"evenodd","transform":"matrix(0 -2.5592 -2.5592 0 43.481 35.237)","sketchType":"MSLayerGroup","key":1},React.createElement("path",{"sketchType":"MSShapeGroup","transform":"matrix(1,0,0,-1,0,14.444)","d":"m.2145 6.7086c-.286.28889-.286.75432 0 1.0272l6.4032 6.4682c.31778.32099.82622.32099 1.144 0s.31778-.83457 0-1.1556l-5.2592-5.3114c-.286-.28889-.286-.75432 0-1.0272l5.2592-5.3123c.31778-.32099.31778-.83457 0-1.1556-.31778-.32099-.82622-.32099-1.144 0l-6.4032 6.4679z"}))]);
}

ChevronDown.displayName = "ChevronDown";

ChevronDown.defaultProps = {"xmlnsSketch":"http://www.bohemiancoding.com/sketch/ns","xmlnsRdf":"http://www.w3.org/1999/02/22-rdf-syntax-ns#","height":"50","width":"50","version":"1.1","xmlnsCc":"http://creativecommons.org/ns#","viewBox":"0 0 50 50","xmlnsDc":"http://purl.org/dc/elements/1.1/"};

module.exports = ChevronDown;

ChevronDown.default = ChevronDown;



//////////////////
// WEBPACK FOOTER
// ./src/app/icons/chevron-down.svg
// module id = 747
// module chunks = 0